import {
  Box,
  Button,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import {
  PowerSettingsNewOutlined,
} from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"; // Icon with circle
import Drawer from './Drawer';
import React, { useState } from "react";
import { useFetchData } from "../../components/hooks/useFetchData";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from '../../components/common/Header'
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Import MUI green tick icon
import axios from "axios";
import dayjs from "dayjs";


const CandidateDashboardPage = () => {
  const name = useSelector((state) => state.auth.user?.name);
  const role = useSelector((state) => state.auth.user?.role);
  const candidateuuid = useSelector((state) => state.auth.user?.candidateuuid);
  const countryid = useSelector((state) => state.auth.user?.countryid);
  const courseid = useSelector((state) => state.auth.user?.courseid);
  const [minLoading, setMinLoading] = useState(true);
  const [candidateEvents, setCandidateEvents] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [set1, setOne] = useState([]);
  const [set2, setTwo] = useState([]);
  const [file, setFile] = useState(null);
  const [interview, setInterview] = useState();
  const [vfsdetails, setVFSDetails] = useState('');

  const navigate = useNavigate();
  const { fetchData, loading } = useFetchData();
  const { enqueueSnackbar } = useSnackbar();
  const isLoading = minLoading || loading["dashboardfollowup"];
  let i = 5;
  const baseUrl = process.env.REACT_APP_API_URL;

  const getCandidateLifecyclEevents = async () => {
    const body = { candidateid: candidateuuid };
    const result = await fetchData("getcandidatelifecycleevents", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setCandidateEvents(result.data);
    }
  }

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const getDocumentsByCourse = async () => {
    const body = { courseid: courseid, countryid: countryid, candidateid: candidateuuid };
    const result = await fetchData("getdocumentsbycoursestocandidate", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setOne(result.data.set1);
      setTwo(result.data.set2);
    }
  };

  // get interview details
  const getScheduledInterview = async () => {
    const body = { candidateid: candidateuuid, interviewstatus: 'Interview Scheduled' };
    const result = await fetchData("getscheduledinterview", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setInterview(result.data.interviewdetails);
    }
  }

    // get VFS details
    const getScheduledVFS = async () => {
      const body = { candidateid: candidateuuid, status: 'VFS Booked' };
      const result = await fetchData("getscheduledvfs", {
        method: "post",
        body: body,
      });
      if (result?.code === 200) {
        setVFSDetails(result.data.vfsdeatils);
      }
    }

  const checkSession = async () => {
    if (role !== 'candidate') {
      navigate('candidate-login');
    } else {
      await getScheduledInterview();
      await getScheduledVFS();
      await getCandidateLifecyclEevents();
      await getDocumentsByCourse();
    }
  }

  React.useEffect(() => {
    checkSession();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
  }, []);

  const handleUpload = async (file, docid) => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await axios.post(baseUrl + 'savedocumentsofcandidate', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'candidateuuid': candidateuuid,
          'documentid': docid,
        },
      });
      if (response.data.code === 200) {
        getDocumentsByCourse();
        enqueueSnackbar(response.data.message || "Successfull!", {
          variant: "success",
        });
      } else {
        enqueueSnackbar(response.data.message || "Something went wrong!", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };


  return (
    <div className="candidate-bg">
      <Header />
      {isLoading ? (
        <Skeleton sx={{ mt: 3 }} variant="rounded" width={120} height={14} />
      ) : (
        <div>
          <h4 className="candidatename"></h4>
        </div>
      )}
        {isLoading ? (
          <Skeleton sx={{ ml: 2, mt: 5 }} variant="rounded" width={155} height={25} />
        ) : (
          <h4 className="candidatename">Hello {name} </h4>
        )}
        {isLoading ? (
          <Skeleton sx={{ ml: 2, mt: 5 }} variant="rounded" width={800} height={50} />
        ) : (
          <Typography
            sx={{ mt: 2, mb: 0.5 }}
            fontWeight={700}
            fontSize={48}
            color="#272727"
            className="journey"
          >
            Explore your journey at a glance.
          </Typography>
        )}
      {isLoading ? (
         <div
         style={{
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           height: '100vh', // Full viewport height
         }}
       >
         <Skeleton
           sx={{ mt: 0 }}
           variant="rounded"
           width={690}
           height={900}
           mt={1}
           mb={2}
         />
       </div>
      ) : (
        <>
        {interview.length > 0?(
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
            mb={2}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                borderRadius: "100px",
                border: "1px solid var(--Error-700, #B3411A)",
                backgroundColor: "var(--Error-500, #D64D1F)",
                padding: "8px 24px",
                width: "480px", // adjust as needed
              }}
            >
              <InfoOutlinedIcon sx={{ color: "var(--Text-Secondary-Default, #F9F9F9)", fontSize: 24 }} />
              <Typography
                sx={{
                  color: "var(--Text-Secondary-Default, #F9F9F9)",
                  fontSize: "var(--TypeStyle-H6, 14px)",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "var(--TypeHeight-H6, 29px)", // Maintain line height
                  textAlign: "center",
                }}
              >
                Your interview is set for {dayjs(interview[0].interviewdate).format("LL")}, at {dayjs(interview[0].interviewtime, "HH:mm:ss").format("h:mm A")}. Notes : {interview[0].notes}
                {/* Your interview is set for 10 November 2024, at 10:30 AM. */}
              </Typography>
            </Box>
          </Stack>
          ):(null)}
          {vfsdetails.length > 0?(
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
            mb={2}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                borderRadius: "100px",
                border: "1px solid var(--Error-700, #B3411A)",
                backgroundColor: "var(--Error-500, #D64D1F)",
                padding: "8px 24px",
                width: "480px", // adjust as needed
              }}
            >
              <InfoOutlinedIcon sx={{ color: "var(--Text-Secondary-Default, #F9F9F9)", fontSize: 24 }} />
              <Typography
                sx={{
                  color: "var(--Text-Secondary-Default, #F9F9F9)",
                  fontSize: "var(--TypeStyle-H6, 14px)",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "var(--TypeHeight-H6, 29px)", // Maintain line height
                  textAlign: "center",
                }}
              >
                Your VFS slot set for {dayjs(vfsdetails[0].slotdate).format("LL")}
                {/* Your interview is set for 10 November 2024, at 10:30 AM. */}
              </Typography>
            </Box>
          </Stack>
          ):(null)}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
          >
            <div style={{ position: "relative", zIndex: 2 }}>
              <svg
                width={109}
                height={137}
                viewBox="0 0 109 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="#3A80F7" d="M0 0H109V104H0z" />
                <text
                  x="50%"
                  y="50%"
                  fill="#fff"
                  fontSize="50px"
                  fontWeight="bold"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  1
                </text>
                <path d="M72 104H0l72 33v-33z" fill="#1A3A6F" />
              </svg>
            </div>

            {/* Middle white box with paragraph */}
            <div className="cand-lifecycle-event-box-style">
              <span className="cand-lifecycle-event">
                Lead generated
              </span>
              <CheckCircleIcon className="ly-tick-icon" />
            </div>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
          >
            <div style={{ position: "relative", zIndex: 2 }}>
              <svg
                width={109}
                height={137}
                viewBox="0 0 109 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="#3A80F7" d="M0 0H109V104H0z" />
                <text
                  x="50%"
                  y="50%"
                  fill="#fff"
                  fontSize="50px"
                  fontWeight="bold"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  2
                </text>
                <path d="M72 104H0l72 33v-33z" fill="#1A3A6F" />
              </svg>
            </div>

            {/* Middle white box with paragraph */}
            <div className="cand-lifecycle-event-box-style">
              <span className="cand-lifecycle-event">
                Country and course selected
              </span>
              <CheckCircleIcon className="ly-tick-icon" />
            </div>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
          >
            <div style={{ position: "relative", zIndex: 2 }}>
              <svg
                width={109}
                height={137}
                viewBox="0 0 109 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="#3A80F7" d="M0 0H109V104H0z" />
                <text
                  x="50%"
                  y="50%"
                  fill="#fff"
                  fontSize="50px"
                  fontWeight="bold"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  3
                </text>
                <path d="M72 104H0l72 33v-33z" fill="#1A3A6F" />
              </svg>
            </div>

            {/* Middle white box with paragraph */}
            <div className="cand-lifecycle-event-box-style">
              <span className="cand-lifecycle-event">
                Converted to candidate
              </span>
              <CheckCircleIcon className="ly-tick-icon" />
            </div>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            flexWrap="wrap"
            mt={1}
          >
            <div style={{ position: "relative", zIndex: 2 }}>
              <svg
                width={109}
                height={137}
                viewBox="0 0 109 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="#3A80F7" d="M0 0H109V104H0z" />
                <text
                  x="50%"
                  y="50%"
                  fill="#fff"
                  fontSize="50px"
                  fontWeight="bold"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  4
                </text>
                <path d="M72 104H0l72 33v-33z" fill="#1A3A6F" />
              </svg>
            </div>

            {/* Middle white box with paragraph */}
            <div className="cand-lifecycle-event-box-style">
              <span className="cand-lifecycle-event">
                Documents
              </span>
              <Button
                style={{
                  borderRadius: '20px',
                  border: '0.5px solid var(--Border-Primary, #3A80F7)',
                  background: 'var(--Bg-Tonal-Blue, #E1ECFE)',
                  color: 'var(--Text-Tonal-Blue, #3A80F7)',
                  textAlign: 'center',
                  fontSize: 'var(--TypeStyle-H5, 18px)',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'var(--TypeHeight-H5, 29px)',
                  padding: '10px 20px', // You can adjust padding as needed
                  cursor: 'pointer',
                  textTransform: 'none',
                }}
                onClick={toggleDrawer}
              >
                Upload
              </Button>
            </div>
          </Stack>
          {candidateEvents.map((option) => (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={2}
              flexWrap="wrap"
              mt={1}
              key={option.id}
            >
              <div style={{ position: "relative", zIndex: 2 }}>
                <svg
                  width={109}
                  height={137}
                  viewBox="0 0 109 137"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="#3A80F7" d="M0 0H109V104H0z" />
                  <text
                    x="50%"
                    y="50%"
                    fill="#fff"
                    fontSize="50px"
                    fontWeight="bold"
                    textAnchor="middle"
                    dominantBaseline="middle"
                  >
                    {i}
                  </text>{i++}
                  <path d="M72 104H0l72 33v-33z" fill="#1A3A6F" />
                </svg>
              </div>

              {/* Middle white box with paragraph */}
              <div className="cand-lifecycle-event-box-style">
                <span className="cand-lifecycle-event">
                  {option.lifecycle_name}
                </span>
                <CheckCircleIcon className="ly-tick-icon" />
              </div>
            </Stack>
          ))}
        </>
      )}
      <Drawer isOpen={isDrawerOpen} onClose={toggleDrawer}
        set1={set1}
        set2={set2}
        handleUpload={handleUpload}
        candidateuuid={candidateuuid}
        baseUrl={baseUrl}
      />
    </div>
  );
};

export default CandidateDashboardPage;
